module.exports = __webpack_public_path__ + "img/offers_blue.c76c22b9.svg";